import type { Locale, Word } from "./types";

export function displayTerm(word: Word, locale: Locale): string {
  return locale === "en" && word.termEn ? word.termEn : word.term;
}

export function displayTranslation(word: Word, locale: Locale): string | undefined {
  if (word.termEn) return locale === "en" ? word.term : word.termEn;
  if (word.language === "la" && word.translation?.includes(" / ")) return word.translation.split(" / ")[locale === "fr" ? 0 : 1];
  return word.translation;
}

export function hasEditorialExample(word: Word, locale: Locale): boolean {
  const example = word.example[locale];
  return !example.startsWith("Le passage emploie")
    && !example.startsWith("Le texte emploie")
    && !example.startsWith("The passage uses")
    && !example.startsWith("The text uses")
    && !example.includes("condense une idée")
    && !example.includes("condenses an idea");
}
